import * as React from "react"
import * as lineupNavStyles from "./lineup-nav.css"
import  DownloadBumbershootAppLink from "../components/download-bumbershoot-app-link"

import {
    NavLink,
    VisuallyHidden,
  } from "./ui"
  
export default function LineupNav({currentPath}) {
    return null;
    return (
       
        <div className={lineupNavStyles.menuBarWrapper}>
            <div className={lineupNavStyles.menuBar}>
                <div className={lineupNavStyles.menuBarArts}>
                <NavLink to="/artist-lineup" target="_blank">
                    <VisuallyHidden>Arts</VisuallyHidden>
                    <span className={lineupNavStyles.menuBarItem}>
                    Visual Arts
                    </span>
                </NavLink>
                </div>
                <div className={lineupNavStyles.menuBarMusic}>
                <NavLink to="/music-lineup">
                    <VisuallyHidden>Music</VisuallyHidden>
                    <span className={lineupNavStyles.menuBarItem}>
                    Music
                    </span>
                </NavLink>
                </div>
                <div className={lineupNavStyles.menuBarCulinary}>
                <NavLink to="/culinary-lineup">
                    <VisuallyHidden>Eat & Drink</VisuallyHidden>
                    <span className={lineupNavStyles.menuBarItem}>
                    Eat & Drink
                    </span>
                </NavLink>
                </div>
            </div>
            <div style={{textAlign: "center"}}>
                {
                    /*
            <DownloadBumbershootAppLink currentPath={currentPath}/>
                    */
                }
            </div>
        </div>
    )
}